const logos = {
    logo_nomanejes: { src: "/images/banner/logo_nomanejes.svg", alt: "Logo Nomanejes", href: "https://www.nomanejes.com" },
    logo_puerto_rico_car_transfer: { src: "/images/banner/logo_puertoricocartransfer.svg", alt: "Logo Puerto Rico Car Transfer", href: "https://www.puertoricocartransfer.com" },
    logo_carro_a_centro_america: { src: "/images/banner/logo_carrosacentroamerica.svg", alt: "Logo Carro a Centro America", href: "https://www.carrosacentroamerica.com" },
    logo_pr_autotransport: { src: "/images/banner/logo_prautotransport.svg", alt: "Logo PR Autotransport", href: "https://www.prautotransport.com" },
    logo_carmoversus: { src: "/images/banner/logo_carmoversus.svg", alt: "Logo Carmoversus", href: "https://www.carmoversus.com" },
    logo_shipshippersusa: { src: "/images/banner/logo_shipshippersusa.svg", alt: "Logo Shipshippers USA", href: "https://www.shipshippersusa.com" },
    logo_ratesautotransport: { src: "/images/banner/logo_ratesautotransport.svg", alt: "Logo Rates Autotransport", href: "https://www.ratesautotransport.com" },
    logo_tucarroporusa: { src: "/images/banner/logo_tucarroporusa.svg", alt: "Logo Tu Carro Por Usa", href: "https://www.tucarroporusa.com" },
    logo_tcpamerica: { src: "/images/banner/logo_tcpamerica.svg", alt: "Logo TCP America", href: "https://www.tucarroporamerica.com" },
}

const logos_ally = {
    logo_ally_centraldispatch: { src: "/images/banner/logo_ally_centraldispatch.svg", alt: "Logo Ally Central Dispatch", href: "https://www.centraldispatch.com" },
    logo_ally_seaboard: { src: "/images/banner/logo_ally_seaboardmarine.svg", alt: "Logo Ally Seaboard", href: "https://www.seaboardmarine.com" },
    logo_ally_trailerbridge: { src: "/images/banner/logo_ally_trailerbridge.svg", alt: "Logo Ally Trailer Bridge", href: "https://www.trailerbridge.com" },
    logo_crowley: { src: "/images/banner/logo_ally_crowley.svg", alt: "Logo Crowley", href: "https://www.crowley.com" },
    logo_interport: { src: "/images/banner/logo_ally_interport.svg", alt: "Logo Interport", href: "https://interporthouston.com" },
    logo_cmacgm: { src: "/images/banner/logo_ally_cmacgm.svg", alt: "Logo CMACGM", href: "https://www.cmacgm-group.com" },
}

const logos_payments = {
    logo_visa: { src: "/images/banner/logo_payment_visa.svg", alt: "Logo Visa", href: "https://www.visa.com" },
    logo_mastercard: { src: "/images/banner/logo_payment_mastercard.svg", alt: "Logo Mastercard", href: "https://www.mastercard.com" },
    logo_americanexpress: { src: "/images/banner/logo_payment_americanexpress.svg", alt: "Logo Paypal", href: "https://www.americanexpress.com" },
}

export default function BannerGarlasLLCLogos() {
    return (
        <div className="d-flex flex-column w-100 justify-content-between">
            {/* Primera fila */}
            <div className="row no-gutters align-items-center" style={{ height: "50px" }}>
                {Object.entries(logos).slice(0, 5).map(([key, logo]) => (
                    <div key={key} className="col text-center">
                        <a href={logo.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                            <img
                                src={logo.src}
                                alt={logo.alt}
                                className={`img-fluid logo-img`}
                            />
                        </a>
                    </div>
                ))}
            </div>
            <div className="d-flex row align-items-center" >
                {Object.entries(logos).slice(5).map(([key, logo]) => (
                    <div key={key} className={`text-center col`}>
                        <a href={logo.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                            <img
                                src={logo.src}
                                alt={logo.alt}
                                className={`img-fluid w-auto h-100 logo-img`}
                            />
                        </a>
                    </div>
                ))}
            </div>

            {/* Segunda fila */}
            <div className="row no-gutters align-items-center mb-5" style={{ height: "40px" }}>
                {Object.entries(logos_ally).map(([key, logo]) => (
                    <div key={key} className="col text-center">
                        <a href={logo.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                            <img
                                src={logo.src}
                                alt={logo.alt}
                                className={`img-fluid logo-img ${ key === "logo_centraldispatch" ? "logo-large" : ""}`}
                            />
                        </a>
                    </div>
                ))}
            </div>

            {/* Métodos de pago */}
            <div className="d-flex justify-content-center gap-3 w-100 align-items-center">
                {Object.values(logos_payments).map((logo, index) => (
                    <a key={index} href={logo.href} target="_blank" rel="noopener noreferrer" className="banner-logo-link">
                        <img src={logo.src} height="30px" alt={logo.alt} />
                    </a>
                ))}
                <div className="d-flex w-100 justify-content-end">
                    <p className="text-center m-0" style={{ fontSize: "1.1em" }}>
                        Comunícate con alguna de nuestras empresas HOY.
                    </p>
                </div>
            </div>
        </div>
    )
}